module.exports = __webpack_public_path__ + "static/media/mastercard.a9a1b34a.svg";